<template>
  <div id="contenedor-desktop-listado-contrato-fechas">
    <v-data-table
      :headers="headers"
      :items="listado"
      :sort-by="['fecha']">
      <template v-slot:[`item.tipo`]="{ item }">
        <v-chip>
          {{ listadoDeTipos[item.tipo] }}
        </v-chip>
      </template>
      <template v-slot:[`item.fecha`]="{ item }">
        {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <!-- BOTONES PARA EDITAR Y ELIMINAR -->
        <v-tooltip
        v-if="mixValidaScopesActions(2)"
        top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click="editar(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip
        v-if="mixValidaScopesActions(3)"
        top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
        <!-- <opciones :id="item.id"></opciones> -->
      </template>
    </v-data-table>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import mixContratoFechas from '@/components/administracion/contratos/contrato/fechas/mixContratoFechas';

export default {
  name: 'DesktopListadoContratoFechas',
  mixins: [mixContratoFechas],
  props: {
    listado: Array,
  },
  data() {
    return {
      headers: [
        {
          text: 'Tipo',
          sortable: false,
          value: 'tipo',
        },
        {
          text: 'Fecha',
          sortable: false,
          value: 'fecha',
        },
        {
          text: '',
          value: 'acciones',
          sortable: false,
          align: 'end',
          width: '150',
        },
      ],
    };
  },
  methods: {
    editar(fecha) {
      eventBus.$emit('editar-fecha-contrato', fecha);
    },
    borrar(fecha) {
      eventBus.$emit('borrar-fecha-contrato', fecha);
    },
  },
};
</script>

<style lang="scss">

</style>
